import React, { useEffect} from "react"
import { useTranslation } from "react-i18next"
import "./Clients.css"
import video2 from "../assets/videoclients.mp4"
import icon1 from "../assets/icon-1.png"
import icon2 from "../assets/icon-2.png"
import icon3 from "../assets/icon-3.png"
import icon4 from "../assets/icon-4.png"
import icon5 from "../assets/icon-5.png"
import icon6 from "../assets/icon-6.png"
import icon7 from "../assets/icon-7.png"
import icon8 from "../assets/icon-8.png"
import icon9 from "../assets/icon-9.png"
import icon10 from "../assets/icon-10.png"
import icon11 from "../assets/icon-11.png"
import img1 from "../assets/pictest5.jpg"
import img2 from "../assets/pictest3.png"
import img3 from "../assets/pictest4.jpg"
import img4 from "../assets/pictest2.jpg"
import img5 from "../assets/6.png"
import img6 from "../assets/3.png"
import img7 from "../assets/4.png"
import img8 from "../assets/2.png"

const logos = [
  icon1,
  icon2,
  icon3,
  icon4,
  icon5,
  icon6,
  icon7,
  icon8,
  icon9,
  icon10,
  icon11,
];

const Clients = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-fade-in");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in-view");
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div className={`clients-wrapper ${isArabic ? "rtl text-right" : "ltr text-left"}`}>
      <div className="clients-hero">
        <video className="clients-video" autoPlay loop muted playsInline>
          <source src={video2} type="video/mp4" />
        </video>
        <div className="clients-overlay">
          <h1>{t("clients.hero.title")}</h1>
          <p>{t("clients.hero.subtitle")}</p>
        </div>
        <svg
          className="clients-hero-curve"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 150"
          preserveAspectRatio="none"
        >
          <path
            d="M0,0 C480,150 960,150 1440,0 L1440,150 L0,150 Z"
            fill="white"
          />
        </svg>
      </div>

      <section className="clients-text-section scroll-fade-in slide-in-left">
        <h1>
          <span className="highlight">{t("clients.section1.highlight")}</span>{" "}
          {t("clients.section1.title")}
        </h1>
        <p>{t("clients.section1.description")}</p>
      </section>

      <section className="clients-visual scroll-fade-in slide-in-right">
        {[img1, img2, img3, img4].map((img, i) => (
          <img key={i} src={img} alt="" className="clients-img bubble-float" />
        ))}
      </section>

      <section className="clients-text-section scroll-fade-in slide-in-left">
        <h1>
          <span className="highlight">{t("clients.section2.highlight")}</span>{" "}
          {t("clients.section2.title")}
        </h1>
        <p>{t("clients.section2.description")}</p>
      </section>

      <section className="clients-visual clients-visual-secondary scroll-fade-in slide-in-right">
        {[img5, img6, img7, img8].map((img, i) => (
          <img key={i} src={img} alt="" className="clients-img bubble-float" />
        ))}
      </section>

      <section className="clients-carousel-section">
        <div className="clients-wave-top absolute -top-1 rotate-180 w-full z-10">
          <div id="clients_cloud_top"></div>
        </div>

        <div className="clients-marquee-wrapper">
          <div className="clients-marquee-row scroll-left">
            <div className="clients-marquee-track">
              {[...logos, ...logos].map((logo, index) => (
                <img
                  key={`left-${index}`}
                  src={logo}
                  alt={`logo-${index}`}
                  className="clients-marquee-logo"
                />
              ))}
            </div>
          </div>
          <div className="clients-marquee-row scroll-right">
            <div className="clients-marquee-track reverse">
              {[...logos, ...logos].map((logo, index) => (
                <img
                  key={`right-${index}`}
                  src={logo}
                  alt={`logo-${index}`}
                  className="clients-marquee-logo"
                />
              ))}
            </div>
          </div>
        </div>

        <div className="clients-wave-bottom absolute bottom-0 w-full z-10">
          <div id="clients_cloud_bottom"></div>
        </div>
      </section>
    </div>
  )
}

export default Clients